import { render, staticRenderFns } from "./env-item-right.vue?vue&type=template&id=64b08dec&scoped=true"
import script from "./env-item-right.vue?vue&type=script&lang=js"
export * from "./env-item-right.vue?vue&type=script&lang=js"
import style0 from "./env-item-right.vue?vue&type=style&index=0&id=64b08dec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b08dec",
  null
  
)

export default component.exports